import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api } from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [me, setMe] = useState(null); // { user, shop }
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshMe = useCallback(async () => {
    const token = localStorage.getItem('talyer_token');
    if (!token) {
      setMe(null);
      setLoading(false);
      return null;
    }
    try {
      const { data } = await api.get('/auth/me');
      setMe(data);
      return data;
    } catch {
      localStorage.removeItem('talyer_token');
      setMe(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshMe();
    api.get('/config').then(({ data }) => setConfig(data)).catch(() => {});
  }, [refreshMe]);

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    localStorage.setItem('talyer_token', data.token);
    const meData = { user: data.user, shop: data.shop };
    setMe(meData);
    setLoading(false);
    return meData;
  };

  const signup = async (payload) => {
    const { data } = await api.post('/auth/signup', payload);
    localStorage.setItem('talyer_token', data.token);
    setMe({ user: data.user, shop: data.shop });
    setLoading(false);
    return data;
  };

  const logout = () => {
    localStorage.removeItem('talyer_token');
    setMe(null);
  };

  return (
    <AuthContext.Provider value={{ me, config, loading, login, signup, logout, refreshMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
